import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import * as React from 'react'
import { useIntl } from 'react-intl'

function FaqWrapper({ children }: React.PropsWithChildren) {
  const intl = useIntl()

  return <Pane>
    <PaneBody size="xl-y">
      <LayoutContainer>
        <VerticalSpacer gap={40}>
          <Heading variant="heading3" align="center" as="h3">
            {intl.formatMessage({
              id: 'LGdYoAjNPr57Jr6GDql7',
              defaultMessage: 'Frequently Asked Questions',
            })}
          </Heading>
          {children}
        </VerticalSpacer>
      </LayoutContainer>
    </PaneBody>
  </Pane>
}

export default FaqWrapper
